import { generate } from '@/utils/request';
const config = {
  prefix: '',
  items: [
    // 查询导入历史
    { key: 'getImportManager', url: '{prefix}/v1/{organizationId}/import/manager', method: 'GET' },
    // 从文件导入临时表(异步)
    {
      key: 'importDataUpload',
      url: '{prefix}/v1/{organizationId}/import/data/data-upload',
      method: 'POST',
      type: 'form',
    },
    // 自动导入到正式表，一次执行三个流程(同步)
    {
      key: 'autoImport',
      url: '{prefix}/v1/{organizationId}/import/data/sync/auto-import',
      method: 'POST',
      type: 'form',
    },
  ],
};
export default {
  ...generate(config),
};
